export default {
  materials: [
    {
      name: 'Plast',
      color: 'yellow',
      img: 'pet',
      information: {
        allowed: [''],

        notAllowed: ['mastné ani jinak znečištěné obaly']
      },
      material: [
        {
          id: 0,
          name: 'Polyethylentereftalát',
          codeName: 'PET',
          codeNumber: 1
        },
        {
          id: 1,
          name: 'Vysokohustotní (lineární) polyetylén',
          codeName: 'HDPE',
          codeNumber: 2
        },
        {
          id: 2,
          name: 'Polyvinylchlorid',
          codeName: 'PVC',
          codeNumber: 3
        },
        {
          id: 3,
          name: 'Nízkohustotní (rozvětvený) polyetylén',
          codeName: 'LDPE',
          codeNumber: 4
        },
        {
          id: 4,
          name: 'Polypropylén',
          codeName: 'PP',
          codeNumber: 5
        },
        {
          id: 5,
          name: 'Polystyren',
          codeName: 'PS',
          codeNumber: 6
        },
        {
          id: 6,
          name: 'Ostatní',
          codeName: '',
          codeNumber: 7
        }
      ]
    },
    {
      name: 'Papír',
      color: 'blue',
      img: 'papir',
      information: {
        allowed: [
          'barevné sklo (například láhve od vína, alkoholických i nealkoholických nápojů)',
          'tabulové sklo – to třídíme vždy do zeleného kontejneru!'
        ],

        notAllowed: [
          'Obaly od vajíček',
          'ruličky od toaletního papíru',
          'mastný, promáčený nebo jakkoliv znečištěný papír',
          'uhlový a voskovaný papír',
          'papír zatavený do fólie',
          'použité pleny a dámské hygienické potřeby',
          'použité papírové utěrky a kapesníky'
        ]
      },
      material: [
        {
          id: 0,
          name: 'Vlnitá lepenka',
          codeName: 'Pap',
          codeNumber: 20
        },
        {
          id: 1,
          name: 'Hladká lepenka',
          codeName: 'Pap',
          codeNumber: 21
        },
        {
          id: 2,
          name: 'Ostatní',
          codeName: 'Pap',
          codeNumber: 22
        }
      ]
    },

    {
      name: 'Sklo',
      color: 'white',
      img: 'sklo',
      information: {
        allowed: [],

        notAllowed: []
      },
      material: [
        {
          id: 0,
          name: 'Bílé/Čiré sklo',
          codeName: 'Gl',
          codeNumber: 70,
          color: 'white'
        },
        {
          id: 1,
          name: 'Zelené sklo',
          codeName: 'Gl',
          codeNumber: 71,
          color: 'green'
        },
        {
          id: 2,
          name: 'Hnědé sklo',
          codeName: 'Gl',
          codeNumber: 72,
          color: 'green'
        }
      ]
    },
    {
      name: 'KARTONOVÉ NÁPOJE',
      color: 'orange',
      img: 'tetra',
      information: {
        allowed: [
          'Plechovky od nápojů (nápojové plechovky)',
          'Kovové uzávěry, šroubovací uzávěry/víčka',
          'Konzervy',
          'Alobal',
          'Hliníková víčka',
          'Hliníkové obaly od potravin (pozor na obaly spojené s dalším materiálem)'
        ],

        notAllowed: [
          'Nápojové kartony',
          'Spreje a deodoranty se zbytky obsahu',
          'Plechovky od barev, laků atd',
          'Elektroodpad',
          'Baterie.'
        ]
      },
      material: [
        {
          id: 0,
          name: 'Papír a lepenka/plast',
          codeName: 'C/*',
          codeNumber: 81
        },
        {
          id: 1,
          name: 'Papír a lepenka/plast/hliník',
          codeName: 'C/PAP',
          codeNumber: 84
        }
      ]
    },
    {
      name: 'Kovy',
      color: 'grey',
      img: 'kovy',
      information: {
        allowed: [
          'Plechovky od nápojů (nápojové plechovky)',
          'Kovové uzávěry, šroubovací uzávěry/víčka',
          'Konzervy',
          'Alobal',
          'Hliníková víčka',
          'Hliníkové obaly od potravin (pozor na obaly spojené s dalším materiálem)'
        ],

        notAllowed: [
          'Nápojové kartony',
          'Spreje a deodoranty se zbytky obsahu',
          'Plechovky od barev, laků atd',
          'Elektroodpad',
          'Baterie.'
        ]
      },
      material: [
        {
          id: 0,
          name: 'Ocel',
          codeName: 'Fe',
          codeNumber: 40
        },
        {
          id: 1,
          name: 'Hliník',
          codeName: 'Alu',
          codeNumber: 41
        }
      ]
    },
    {
      name: 'Směsný odpad',
      color: '',
      img: 'smesny',
      information: {
        allowed: [],

        notAllowed: []
      },
      material: [
        {
          id: 0,
          name: 'Papír a lepenka/různé kovy ',
          codeName: 'C/*',
          codeNumber: 80,
          allowed: false
        },

        {
          id: 2,
          name: 'Papír a lepenka/hliník',
          codeName: 'C/*',
          codeNumber: 82,
          allowed: false
        },
        {
          id: 3,
          name: 'Papír a lepenka/ocelový pocín. plech',
          codeName: 'C/*',
          codeNumber: 83,
          allowed: false
        },

        {
          id: 5,
          name: 'Papír a lepenka/plast/hliník/ocelový pocínovaný plech',
          codeName: 'C/*',
          codeNumber: 85,
          allowed: false
        },
        {
          id: 6,
          name: 'Plast/hliník',
          codeName: 'C/*',
          codeNumber: 90,
          allowed: false
        },
        {
          id: 7,
          name: 'Plast/ocelový pocínovaný plech ',
          codeName: 'C/*',
          codeNumber: 91,
          allowed: false
        },
        {
          id: 8,
          name: 'Plast/různé kovy',
          codeName: 'C/*',
          codeNumber: 92,
          allowed: false
        },
        {
          id: 9,
          name: 'Sklo/plast ',
          codeName: 'C/*',
          codeNumber: 95,
          allowed: false
        },
        {
          id: 10,
          name: 'Sklo/hliník ',
          codeName: 'C/*',
          codeNumber: 96,
          allowed: false
        },
        {
          id: 11,
          name: 'Sklo/ocelový pocínovaný plech',
          codeName: 'C/*',
          codeNumber: 97,
          allowed: false
        },
        {
          id: 12,
          name: 'Sklo/různé kovy',
          codeName: 'C/*',
          codeNumber: 98,
          allowed: false
        }
      ]
    }
  ]
}
